import { permissoes, routesNames } from '@/core/constants'
import RelatorioView from '@/views/pages/relatorios/RelatorioView.vue'
import RelatorioPersonalizadoView from '@/views/pages/relatorios/personalizado/RelatorioPersonalizadoView.vue'
import ControleAdesoesView from '@/views/pages/relatorios/controle-adesoes/ControleAdesoesView.vue'
import ControleSaldosView from '@/views/pages/relatorios/controle-saldos/ControleSaldosView'
import PaineisPersonalizadosView from "@/views/pages/relatorios/paineis/PaineisPersonalizadosView.vue";
import PainelListagemView from '@/views/pages/relatorios/painel/listagem/PainelListagemView.vue'
import PainelVisualizacaoView from '@/views/pages/relatorios/painel/visualizacao/PainelVisualizacaoView.vue'

export default [
	{
		name: routesNames.RELATORIO.RELATORIO_VIEW,
		path: '/relatorios',
		component: RelatorioView,
		meta: {
			menu: {
				title: 'Relatórios',
				icon: 'mdi-file',
			},
			page: {
				title: 'Relatórios',
			},
			requiresAuth: true,
			authorities: [permissoes.relatorioPersonalizadoMenu, permissoes.relatorioControleAdesoes, permissoes.painelPersinalizadoMenu, permissoes.relatorioControleSaldos, permissoes.painelMenu],
		},
		children: [
			{
				name: routesNames.RELATORIO.PERSONALIZADO,
				path: '/personalizados',
				component: RelatorioPersonalizadoView,
				meta: {
					menu: {
						title: 'Personalizados',
					},
					page: {
						title: 'Personalizados',
						subtitle: 'Relatórios Personalizados do Sistema.',
					},
					requiresAuth: true,
					authorities: [permissoes.relatorioPersonalizadoMenu],
				},
			},
			{
				name: routesNames.RELATORIO.CONTROLE_ADESOES_VIEW,
				path: '/controle-adesoes',
				component: ControleAdesoesView,
				meta: {
					menu: {
						title: 'Controle de Adesões',
					},
					page: {
						title: 'Relatórios',
						subtitle: 'Controle de Adesões',
					},
					requiresAuth: true,
					authorities: [permissoes.relatorioControleAdesoes],
				},
			},
			{
				name: routesNames.RELATORIO.CONTROLE_SALDOS_VIEW,
				path: '/controle-saldos',
				component: ControleSaldosView,
				meta: {
					menu: {
						title: 'Controle de Saldos',
					},
					page: {
						title: 'Relatórios',
						subtitle: 'Controle de Saldos',
					},
					requiresAuth: true,
					authorities: [permissoes.relatorioControleSaldos],
				},
			},
			{
				name: routesNames.RELATORIO.PERSONALIZADO,
				path: '/paineis',
				component: PaineisPersonalizadosView,
				meta: {
					menu: {
						title: 'Painéis Personalizados',
					},
					page: {
						title: 'Painéis',
						subtitle: 'Painéis Personalizados do Sistema.',
					},
					requiresAuth: true,
					authorities: [permissoes.painelPersinalizadoMenu],
				},
			},
			{
				name: routesNames.RELATORIO.PAINEL_LISTAGEM,
				path: '/painel',
				component: PainelListagemView,
				meta: {
					menu: {
						title: 'Painel',
					},
					page: {
						title: 'Painel',
						subtitle: 'Disponíveis',
					},
					requiresAuth: true,
					authorities: [permissoes.painelMenu],
				},
			},
			{
				name: routesNames.RELATORIO.PAINEL_VISUALIZACAO,
				path: '/painel/visualizacao',
				component: PainelVisualizacaoView,
				meta: {
					page: {
						title: 'Painel',
						subtitle: 'Visualização',
					},
					requiresAuth: true,
					authorities: [permissoes.painelMenu],
				},
			},
		],
	},
]
